import { createFileRoute } from "@tanstack/react-router";
import { ContactPage } from "@/pages/information/contact";
export const Route = createFileRoute("/contact")({
  component: ContactPage,
});
